<!-- eslint-disable indent -->
<template>
  <div class="main" v-cloak v-if="isLoads">

    <div class="el-breadcrumbs">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>

        <el-breadcrumb-item v-if="this.$route.query.isPingPai"
          :to="{ path: '/pages/shop/brandlist?brand_id=' }">全部品牌</el-breadcrumb-item>


        <el-breadcrumb-item v-if="this.$route.query.brand_id" :to="{ path: `/pages/shop/prolist`, query:{
              brand_id:this.$route.query.brand_id,
              name: this.$route.query.name,
              isPingPai:this.$route.query.isPingPai
            } }">{{this.$route.query.name}}</el-breadcrumb-item>

        <el-breadcrumb-item v-if="this.$route.query.cid||this.$route.query.keyword" :to="{ path: `/pages/shop/prolist`, query:{
            cid:this.$route.query.cid,
            name: this.$route.query.name,
            keyword:this.$route.query.keyword,
          } }">{{this.$route.query.name}}</el-breadcrumb-item>

        <el-breadcrumb-item v-if="objItem && objItem.name">{{ objItem.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="shop-info">
      <div class="shop-logo">
        <div class="logo" v-if="shopImg">
          <img :src="shopImg" alt="img" v-viewer />
        </div>
        <div class="logo-main">
          <div class="logo-ul" :style="{ width: `${100 * shopList.length}px` }" v-if="shopList && shopList.length">
            <div class="logo-li" v-for="(item, index) in shopList" :class="{ 'logo-on': index == shopImgIndex }"
              @click="shooImgClick(item, index)">
              <img :src="item" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="shop-text">
        <div class="title" v-if="objItem && objItem.name">
          {{ objItem.name }}
        </div>
        <div class="price-amount">
          <div class="price" v-if="objItem && objItem.market_price">
            原价:<span>￥{{ objItem.market_price }}</span>
          </div>
          <div class="amount" v-if="objItem && objItem.sell_price">
            价格:<span>￥{{ objItem.sell_price }}</span>
          </div>
        </div>
        <div class="xl-lll">
          <div class="xl-text" v-if="objItem&&objItem.brand_name">
            品牌：{{ objItem.brand_name}}
          </div>

          <div class="lll-center">
            销量：{{ objItem.sales ||0}} 件
          </div>

          <div class="lll-text">
            库存：{{ objItem.stock || 0}} 件
          </div>
        </div>

        <!-- <div class="spec-main">
          <div class="spec-title">
            品牌
          </div>
          <div class="texts" v-if="objItem&&objItem.brand_name">
            {{objItem.brand_name}}
          </div>
        </div> -->

        <div class="spec-main" v-for="(item,index) in specData" :key="item.id">
          <div class="spec-title">
            {{item.title}}
          </div>
          <div class="spec-ul">
            <div class="spec-li" :class="{'spec-on':itemt.checked}" v-for="(itemt,indext) in item.items"
              @click="specClick(item,itemt,index,indext)" :key="itemt.id">
              {{itemt.title}}
            </div>
          </div>
        </div>

        <div class="spec_list">
          <div class="spec_li" v-for="(item,index) in specDataList" :class="{'spec_on': spec_data_index == item.name}"
            @mouseover="spec_list_over(item,index)">
            <el-popover placement="top-start" width="250" trigger="hover">
              <div style="width: 250px;height: 250px;">
                <img :src="item.pic" alt="" />
              </div>
              <!-- <el-button ></el-button> -->
              <div slot="reference" class="spec_li_img">
                <img :src="item.pic" alt="" />
              </div>
            </el-popover>
          </div>
        </div>

        <div class="spec-main">
          <div class="spec-title">
            服务
          </div>
          <div class="fuwu-ul">
            <div class="fuwu-li" v-for="(item,indext) in fuwulist">
              <i class="el-icon-circle-check"></i>
              <div class="fuwu-name">
                {{item.name}}
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="demand">
          如需购买请到手机端
        </div> -->

        <div class="pay-button">
          <div>
            <el-button type="danger" @click="paycodeTap"
              style="width: 100%;background: #FFFFFF;color:#F56C6C;line-height: 40px;height: 40px;padding:0;">收藏</el-button>
          </div>
          <div>
            <el-button type="danger" @click="paycodeTap"
              style="width: 100%;line-height: 40px;height: 40px;padding:0;">马上下单</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="shop-incontent">
      <div class="detail-title">
        商品详情
      </div>
      <div v-html="pagecontent">
      </div>
      <!-- <dp :pagecontent="pagecontent"></dp> -->
    </div>

    <!-- title="提示" -->
    <el-dialog width="30%" :visible.sync="dialogVisible" :before-close="handleClose"
      :title="payBtnObj&&payBtnObj.pc_buy_text?payBtnObj.pc_buy_text:''" align="center">
      <div class="dialog-footer">
        <div class="code-logo">
          <img v-if="payBtnObj&&payBtnObj.wechat_mini_code" :src="payBtnObj.wechat_mini_code" alt="" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    Tooltip
  } from 'element-ui';
  // import dp from "../../../components/dp/dp"
  export default {
    // components: {
    //   dp
    // },
    data() {
      return {
        shopImg: 'https://pen.loojj.com/upload/1/20230707/2f2a1c94065f10bbc4522f825d4c62bd.png',
        shopList: [],
        shopImgIndex: 0,
        objItem: {},
        pagecontent: "",
        specData: [],
        isLoads: true,
        fuwulist: [],
        payBtnObj: {},
        dialogVisible: false,
        specDataList: [],
        spec_data_index: -1,
      }
    },
    mounted() {
      this.getShopDetail(); //获取商品信息
      this.getProductSpec(); //获取规格信息
    },
    methods: {
      spec_list_over(item, index) {
        // this.spec_data_index = item.name;
        // console.log(this.spec_data_index)
      },
      paycodeTap() {
        this.dialogVisible = true;
      },
      handleClose(done) {
        done();
      },
      specClick(item, itemt, index, indext) {
        // var ikUnit = Tooltip("111");

        item.items.forEach((itemts, indexts) => {
          itemts.checked = false;
        })
        itemt.checked = true;
        this.isLoads = false;
        this.isLoads = true;


        this.spec_data_index = 0;
        if (this.specData.length == 1) {
          if (this.specDataList[indext].pic) {
            // this.shopList[0] = this.specDataList[indext].pic;
            this.spec_data_index = this.specDataList[indext].name;

            this.objItem.market_price = this.specDataList[indext].market_price;
            this.objItem.sell_price = this.specDataList[indext].sell_price;
            this.objItem.sales = this.specDataList[indext].sales;
            this.objItem.stock = this.specDataList[indext].stock;
          }
        } else {
          // let keys = index + "," + indext;
          let keys = "";
          this.specData.forEach((itemts, indexts) => {
            itemts.items.forEach((itemst, indexst) => {
              if (itemst.checked) {
                keys += indexst + ","
              }
            })
          })
          keys = keys.slice(0, -1);
          console.log(keys)

          if (this.specDataList[keys] && this.specDataList[keys].pic) {
            // this.shopList[0] = this.specDataList[keys].pic;
            this.spec_data_index = this.specDataList[keys].name;

            this.objItem.market_price = this.specDataList[keys].market_price;
            this.objItem.sell_price = this.specDataList[keys].sell_price;
            this.objItem.sales = this.specDataList[keys].sales;
            this.objItem.stock = this.specDataList[keys].stock;
          }
        }
        console.log(index, indext)
        // console.log(this.spec_data_index, "1");
        // console.log(this.specDataList)
        // this.specDataList.forEach((mmm, xxx) => {
        //   console.log(mmm.name, "2")
        // })




        // this.shopImg = this.shopList[0];
        // console.log(this.spec_data_index)

      },
      getProductSpec() {
        this.$http.post('?s=/apiPc.Product/getProductSpec', { //获取规格信息

            id: this.$route.query.id, //商品id
          })
          .then(response => {
            this.specData = response.data.guigedata;

            this.specDataList = response.data.guigelist;
            // console.log(response)
          })
          .catch(error => {});
      },
      shooImgClick(item, index) {
        this.shopImg = item;
        this.shopImgIndex = index;
      },
      getShopDetail() {
        this.$http.post('?s=/apiPc.Product/product', { //获取商品信息
            id: this.$route.query.id, //商品id
          })
          .then(response => {
            // console.log(response.data.brand_name)
            this.objItem = response.data.product;
            this.fuwulist = response.data.fuwulist;
            this.payBtnObj = response.data.sysset;

            // this.shopImg = this.objItem.pic
            this.shopList = this.objItem.pics;
            this.shopImg = this.shopList[this.shopImgIndex]

            this.pagecontent = JSON.parse(this.objItem.detail)[0].content;
          })
          .catch(error => {});
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    padding: 20px 123px;
    background: #f5f5f5;
    user-select: none;
  }

  .main .dialog-footer .code-logo {
    width: 60%;
    margin: 0 auto;
    padding-bottom: 30px;
  }

  .main .el-breadcrumbs {
    padding: 10px 0 30px 0;
  }

  .main .shop-incontent {
    background: #FFFFFF;
    padding: 10px 20px;
    margin-top: 20px;
  }

  .main .shop-incontent .detail-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 44px;
    padding-bottom: 10px;
  }

  .main .shop-info {
    display: flex;
  }

  .main .shop-info .shop-text .pay-button {
    padding-top: 40px;
    display: flex;
    justify-content: center;
  }

  .main .shop-info .shop-text .pay-button div {
    width: 100px;
    margin: 0 20px;
  }

  .main .shop-info .shop-text .demand {
    font-size: 18px;
    padding-top: 40px;
    text-align: center;
    color: red;
  }

  .main .shop-info .shop-text .spec_list {
    display: flex;
    margin-top: 20px;
  }

  .main .shop-info .shop-text .spec_list .spec_li {
    margin-right: 10px;
    border: 2px solid #EEEEEE;
    cursor: pointer;
    margin-bottom: 0;
    padding-bottom: 0;
    width: 80px;
    height: 80px;
  }

  .main .shop-info .shop-text .spec_list .spec_li .spec_li_img {
    width: 80px;
    height: 80px;
  }

  .main .shop-info .shop-text .spec_list .spec_on {
    border-color: #FF2C3C;
  }

  .main .shop-info .shop-text .spec-main {
    display: flex;
    /* padding-left: 15px; */
    padding-top: 20px;
  }

  .main .shop-info .shop-text .spec-main .fuwu-ul {
    display: flex;
    flex-wrap: wrap;
    margin-right: 20rpx;
  }

  .main .shop-info .shop-text .spec-main .fuwu-ul .fuwu-li {
    display: flex;
    align-items: center;
  }

  .main .shop-info .shop-text .spec-main .fuwu-ul .fuwu-li i {
    color: #FF2C3C;
    font-size: 20px;
    margin-right: 5px;
  }

  .main .shop-info .shop-text .spec-main .fuwu-ul .fuwu-li .fuwu-name {
    font-size: 14px;
    line-height: 32px;
    padding-right: 20px;
  }

  .main .shop-info .shop-text .spec-main .texts {
    font-size: 14px;
    line-height: 32px;
    padding-right: 20px;
  }

  .main .shop-info .shop-text .spec-main .spec-title {
    font-size: 14px;
    line-height: 32px;
    padding-right: 20px;
  }

  .main .shop-info .shop-text .spec-main .spec-ul {
    display: flex;
    flex-wrap: wrap;
  }

  .main .shop-info .shop-text .spec-main .spec-li {
    cursor: pointer;
    line-height: 32px;
    padding: 0 20px;
    background: #F2F3F5;
    margin-right: 20px;
  }

  .main .shop-info .shop-text .spec-main .spec-on {
    background: #FFEEEF;
    color: #FF2C3C;
  }

  .main .shop-info .shop-text .xl-lll {
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #e5e5e5;
  }

  .main .shop-info .shop-text .xl-lll .xl-text {
    font-size: 14px;
    line-height: 48px;
    text-align: left;
    width: 50%;
  }

  .main .shop-info .shop-text .xl-lll .lll-text {
    line-height: 48px;
    font-size: 14px;
    text-align: right;
    width: 50%;
  }


  .main .shop-info .shop-text .xl-lll .lll-center {
    line-height: 48px;
    font-size: 14px;
    text-align: center;
    width: 50%;
  }

  .main .shop-info .shop-logo {
    border-radius: 8px;
    width: 30%;
  }

  .main .shop-info .shop-logo .logo {
    cursor: pointer;
  }

  .main .shop-info .shop-logo .logo-main {
    background: #FFFFFF;
    /* align-items: center; */
    width: 100%;
    overflow-x: scroll;
    padding: 10px 0;
  }

  .main .shop-info .shop-logo .logo-main .logo-ul {
    display: flex;
    padding-right: 10px;
  }

  .main .shop-info .shop-logo .logo-main .logo-ul .logo-li {
    width: 80px;
    height: 80px;
    margin-left: 10px;
    border: 2px solid #EEEEEE;
    cursor: pointer;
    /* flex: 1; */
  }

  .main .shop-info .shop-logo .logo-main .logo-ul .logo-on {
    border-color: #FF2C3C;
  }

  .main .shop-info .shop-text {
    background: #FFFFFF;
    margin-left: 20px;
    flex: 1;
    border-radius: 8px;
    padding: 20px 20px;
  }

  .main .shop-info .shop-text .title {
    font-size: 20px;
    font-weight: bold;
  }

  .main .shop-info .shop-text .price-amount {
    background: #F6F6F6;
    padding: 5px 15px 15px 15px;
    margin-top: 10px;
  }

  .main .shop-info .shop-text .price-amount .price {
    padding-top: 10px;
    font-size: 14px;
  }

  .main .shop-info .shop-text .price-amount .price span {
    padding-left: 10px;
    font-size: 14px;
    text-decoration: line-through;
  }

  .main .shop-info .shop-text .price-amount .amount {
    padding-top: 10px;
    font-size: 14px;
  }

  .main .shop-info .shop-text .price-amount .amount span {
    padding-left: 10px;
    font-size: 26px;
    color: #FF2C3C;
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/shop/shopDetails.vue